import React, { ReactNode } from 'react';
import Container from '@v2/shared/components/Container';

/**
 * The box the page sits in, and where `main` lives.
 *
 * `flex-1` so the footer is pushed to the bottom of a short page — the legacy sheet does
 * the same thing with `#wrapper { min-height: calc(100vh - 305px) }`, which is that rule
 * written in terms of a footer height that has to be kept in step by hand.
 *
 * Every brand's Full draws the container and the padding inside it, so a layout stacked
 * on top of this one never has to ask whether it has been boxed already. See
 * `Layouts/Account`.
 */
export default function Content({ children }: { children: ReactNode }) {
  return (
    <Container className="flex-1">
      <main id="main" role="main" className="py-5">
        {children}
      </main>
    </Container>
  );
}
